import axios from '@/util/axios'
import axiosNoError from '@/util/axios_no_error'
import { NEW_API_CONFIG } from '@/util/constants'
import { isFromAdminSystem } from '@/util/common'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * ノート一覧API
 * @param  {} params={}
 */
export const list = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    start: params.start || 0,
    per_page: params.per_page || 30,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/NT/001', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/NT/001', r).catch(handleError)
  }
}

/**
 * ノート一覧件数取得API
 * @param  {} params={}
 */
export const count = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/NT/002', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/NT/002', r).catch(handleError)
  }
}

/**
 * ノート利用者一覧API
 * @param  {} params={}
 */
export const listUsers = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/NT/003', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/NT/003', r).catch(handleError)
  }
}

/**
 * ノートタグ一覧API
 */
export const listNoteTags = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/NT/004', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/NT/004', r).catch(handleError)
  }
}

/**
 * ノート詳細API
 */
export const detail = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/NT/005', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/NT/005', r).catch(handleError)
  }
}

/**
 * ノート追加API
 */
export const add = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/NT/006', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/NT/006', r).catch(handleError)
  }
}

/**
 * ノート行追加API
 */
export const addNoteLine = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/NT/007', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/NT/007', r).catch(handleError)
  }
}

/**
 * ノート複製API
 */
export const copy = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/NT/008', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/NT/008', r).catch(handleError)
  }
}

/**
 * ノート更新API
 */
export const update = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/NT/009', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/NT/009', r).catch(handleError)
  }
}

/**
 * ノート削除API
 */
export const remove = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/NT/010', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/NT/010', r).catch(handleError)
  }
}

/**
 * ノート用QA詳細取得API
 * @param  {} params={}
 */
export const qaDetail = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/NT/011', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/NT/011', r).catch(handleError)
  }
}

/**
 * ノート利用者権限一覧API
 * @param  {} params={}
 */
export const getUserPermissions = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/NT/012', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/NT/012', r).catch(handleError)
  }
}

/**
 * ノート利用者権限更新API
 * @param  {} params={}
 */
export const updateUserPermissions = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  if (isFromAdminSystem()) {
    const newAxiosNoError = axiosNoError.create(NEW_API_CONFIG)
    return newAxiosNoError.post('/NT/013', r).catch(handleError)
  } else {
    const newAxios = axios.create(NEW_API_CONFIG)
    return newAxios.post('/NT/013', r).catch(handleError)
  }
}
